import React from 'react';
import classnames from 'classnames';
import Product from './product/product';
import productsStyles from './products.module.pcss';
import { ListerProductData } from '../../../../types';
import initGlobalUtils from '../../../../utils/globalUtils';

interface ProductsProps {
  products: ListerProductData[];
  rid: string;
}

function Products({ products, rid }: ProductsProps): React.ReactElement {
  React.useEffect(() => {
    initGlobalUtils('load', products);
  }, []);

  return (
    <div id="products" className={classnames(productsStyles.products)}>
      <div className={classnames(productsStyles['products-inner'])}>
        {products.map((p, index) => (
          <Product key={p.code} index={index} product={p} rid={rid} />
        ))}
      </div>
    </div>
  );
}

export default Products;
